<template>
	<div class="position-relative">
		
		<div class="cart" @click="showAlert=true">
			<div class="icon-cart" >
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="icon icon-tabler icon-tabler-shopping-cart"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					stroke-width="2"
					stroke="currentColor"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
					<circle cx="6" cy="19" r="2"></circle>
					<circle cx="17" cy="19" r="2"></circle>
					<path d="M17 17h-11v-14h-2"></path>
					<path d="M6 5l14 1l-1 7h-13"></path>
				</svg>
			</div>
			<div class="badge" v-if="cart.totalQty > 0">{{ cart.totalQty }}</div>
		</div>


		<b-sidebar class="sidebar" title="Carrito" right shadow v-model="showAlert" :backdrop="true">
			<div class="cart-list" v-if="cart.products && cart.products.length > 0">
				<div v-for="(product, index) in cart.products" :key="index" class="product">
					<div class="image" >
						<img v-if="product.variant && product.variant.image" :src="product.variant.image.urlThumb" alt="" class="img-fluid" />
						<img v-else-if="product.product.image" :src="product.product.image.urlThumb" alt="" class="img-fluid" />
					</div>
					<div class="info">
						<div class="name">{{ product.product.name }}</div>
						<div class="variant" v-if="product.variant">{{ product.variant.name }}</div>
						<div class="d-flex">
							<div class="quantity">{{product.qty}} x</div>
							<div class="price" v-if="product.product.priceWithoutTaxes"><small>U$S</small> {{ product.product.priceWithoutTaxes.toFixed(2) }} <small>+iva</small></div>
						</div>
					</div>
					<div class="">
						<div class="btn btn-remove" @click="removeProduct(product)">
							<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-trash" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<line x1="4" y1="7" x2="20" y2="7"></line>
							<line x1="10" y1="11" x2="10" y2="17"></line>
							<line x1="14" y1="11" x2="14" y2="17"></line>
							<path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
							<path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
							</svg>
						</div>
					</div>
				</div>
			</div>
				<div class="cart-list mt-4" v-if="!cart.products || cart.products.length== 0">
					<p class="text-center pt-4">
						Aún no has agregado productos al carrito
					</p>
				</div>	

			<template #footer>
				<div class="foot">
					<div class="total" v-if="cart.priceTotal">
						<div class="title">Total</div>
						<div class="price"><small>U$S</small> {{ cart.priceTotal.toFixed(2) }} </div>
					</div>
					<div class="buttons">
						<router-link tag="a" to="/tienda" class="btn btn-secondary ">Seguir comprando</router-link>
						<router-link tag="a" to="/checkout" class="btn btn-primary ">Finalizar compra</router-link>						
					</div>
				</div>
			</template>
		</b-sidebar>



		<!-- <div class="product-added" :class="{ show: showAlert }" v-if="productAdded">
			<h2><i class="icon icon-check icon-sm invert mr-2"></i> Producto añadido correctamente al carrito</h2>
			<div class="data mt-3">
				<div
					v-if="productAdded.product && productAdded.product.image"
					class="image mr-3"
					:style="'background-image:url(' + productAdded.product.image.url + ')'"
				></div>
				<div>
					<div class="title">{{ productAdded.product.name }}</div>
					<div v-if="productAdded.variant">
						{{productAdded.variant.name}}
					</div>
					<div class="price mt-2">
						<span class="currency">U$S</span>
						<span class="amount">{{ productAdded.priceUnit }}</span>
						<small class="ml-1">+ IVA</small>
					</div>
				</div>
			</div>
			<div class="d-flex flex-wrap w-100 justify-content-between mt-3">
				<router-link tag="a" to="/tienda" class="btn btn-secondary ">Seguir comprando</router-link>
				<router-link tag="a" to="/checkout" class="btn btn-primary ">Finalizar compra</router-link>
			</div>
		</div> -->

	</div>
</template>

<script>
export default {
	name: "CartNavbar",
	props: ["invert"],
	data() {
		return {
			cantProducts: 0,
			loaded: false,
			showAlert: false,
			productAdded: null
		}
	},
	computed:{
		cart:{	
			get: function () {
				return this.$store.getters.cart
    		},
		},
		cartAdded (){
			return this.$store.getters.cartAdded
		}
	},

	watch: {
		'$store.state.cartAdded': {
			deep: true,
			handler(newVal) {
				
				if(newVal){
					// this.productAdded = newVal
					this.showAlert = true
				}
			}
		},
	},

	methods: {
		showProductAdded() {
			
			
				this.showAlert = true
			
			
		},
		removeProduct(product){
			this.cartRemoveItem(product.id)
			
		}
	}
}
</script>
<style scoped lang="scss">
.cart {
	position: relative;
}

.sidebar{
	& ::v-deep .b-sidebar{
		background-color: #ffffff !important;
		.b-sidebar-header{
			font-weight: 400;
			font-size:1.2rem;
		}
	}

	.cart-list{
		.product{
			display: flex;
			padding: 12px;
			border-top: 1px solid #f3f3f3;
	
			.image{
				width: 64px;
				height: 64px;
				margin-right: 8px;
			}
			.info{
				display: flex;
				flex-direction: column;
				
				.name{
					font-size: 14px;
					font-weight: 600;
					color: #333;
				}
				.variant{
					font-size: 13px;
					font-weight: 500;
					color: #333;
				}
				.quantity{
					font-size: 14px;
					font-weight: 600;
					color: #333;
					margin-right: 4px;
				}
				.price{
					font-size: 14px;
					font-weight: 600;
					color: #333;
				}
			}

			.btn-remove{
				
				svg{
					width: 18px;
				}
			}
	
		}
	}

	.foot{
		padding: 12px;
		border-top: 1px solid #f3f3f3;
		font-size: 14px;
		font-weight: 600;
		color: #333;
		
		.total{
			padding: 4px;

			.title{
				font-weight: 500;
			}
		}
		.buttons{
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 6px;
			
			.btn{
				flex-grow: 1;
				margin-top: 12px;
				font-size: .8rem;
				padding: 0.5rem 0.75rem;
			}
		}
	}

}



.icon-cart {
	width: 26px;
	height: 26px;
	background-size: contain;
	color: #fff;
	// filter: invert(1);
}
.badge {
	position: absolute;
	top: -16px;
	right: -16px;
	width: 22px;
	height: 22px;
	font-size: 12px;
	padding: 0px;
	font-weight: 400;
	border-radius: 15px;
	background-color: #3a78c9;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
}


.product-added {
	position: fixed;
	width: 530px;
	height: 230px;
	top: -500px;
	right: calc(50% - 205px);
	padding: 12px 18px;
	background-color: #fff;
	color: #000;
	font-weight: 400;
	border-radius: 12px 0px 12px 0px;
	font-size: 14px;
	transform: translateX(500%);
	-webkit-transform: translateX(500%);

	-webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
	-moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
	box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
}
.product-added.show {
	animation: slide-in 0.5s forwards;
	-webkit-animation: slide-in 0.5s forwards;
	top: calc(50% - 100px);
}

.product-added h2 {
	font-size: 17px;
	font-weight: 600;
}
.product-added .image {
	width: 92px;
	height: 92px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
}
.product-added .data {
	display: flex;
	align-items: center;
	padding: 0px;
}
.product-added .title {
	font-size: 20px;
	line-height: 20px;
}
.product-added .price {
	font-size: 15px;
	line-height: 20px;
}
.product-added .price .currency {
	font-size: 14px;
	font-weight: 600;
}
.product-added .price .amount {
	font-size: 20px;
	font-weight: 600;
}

@keyframes slide-in {
	100% {
		transform: translateX(0%);
	}
}

@-webkit-keyframes slide-in {
	100% {
		-webkit-transform: translateX(0%);
	}
}
</style>
